<template>
  <div>
    <contextmenuRecord ref="contextmenuRecord" :contextMenu="contextmenuRow"></contextmenuRecord>
    <ayb-container
      style="width: 100%;"
      :columns="columns"
      :filedID="filedID"
      ref="templateTag"
      @getAllTask="getRecordByTemplateData"
      @deleteResult="deleteResult"
      :templateTitle="templateTitle"
      :bigTemplateTitle="bigTemplateTitle"
      @openSearch="showSearch"
      @getValue="getSelectedResult"
      @handleRightRow="handleRightRow"
      :isBlank="true"
      :isViewType="false"
      :category="18"
      :isControl="isSelectStyle"
      :IsExpand="isSelectStyle"
      :IsShowButton="false"
      :IsShowCustomize="true"
      :isShowHeader="false"
      :isBrowseRecords="false"
      :IsExpandShow="true"
      :styelHeight="100"
      :styelTableHeight="110"
      :Type="0"
    >
      <!-- >isSelectStyle -->
      <template v-slot:customize>
        <el-row style="margin:5px 10px">
          <el-col :span="4">
            <el-radio-group v-model="stateName" size="small" v-if="!isSelectStyle">
              <el-radio-button v-ripple label="列表视图"></el-radio-button>
              <el-radio-button v-ripple label="卡片视图"></el-radio-button>
            </el-radio-group>
          </el-col>
          <el-col :span="16" type="diplay:flex">
            <el-input
              v-model="searchTxt"
              style="width:300px;margin-top: 1px;"
              size="small"
              @keyup.enter.native="searchFullText"
              placeholder="输入文字全文检索"
            >
              <el-button slot="append" @click="searchFullText" icon="el-icon-search"></el-button>
            </el-input>
            <el-button
              type="warning"
              size="small"
              v-ripple.mouseover.500
              style="margin-left:10px"
              @click="showSearch"
            >精确搜索</el-button>
            <el-button
              type="danger"
              size="small"
              v-ripple.mouseover.500
              style="margin-left:10px"
              @click="successed"
            >刷新</el-button>
          </el-col>
          <el-col :span="4">
            <el-button
              type="primary"
              size="small"
              v-if="!isSelectStyle"
              v-ripple.mouseover.500
              @click="addRecord"
            >新增工作记录</el-button>
          </el-col>
        </el-row>
      </template>
      <template v-slot:main="slotProps">
        <el-container>
          <el-main ref="main">
            <div class="recordPanel" :height="slotProps.Height">
              <TaskRecordSearch
                ref="recordSearch"
                @createTemplate="createTemplate"
                @searchRecord="searchRecord"
              ></TaskRecordSearch>
              <RecordSelect ref="recordSelectDialog"></RecordSelect>
              <side-tags-record-dialog
                v-if="!isSelectStyle"
                ref="SideTagsRecordDialog"
                @successed="successed"
              ></side-tags-record-dialog>
              <div v-loading="loading">
                <TaskRecordGrid
                  ref="multipleTable"
                  v-if="stateName === '列表视图'"
                  :isCheckbox="slotProps.expand"
                  @select="select"
                  @select-all="selectAll"
                  @successed="successed"
                  :source="dataSource"
                ></TaskRecordGrid>
                <div :style="{ height: tabHeight + 'px' }" v-if="stateName === '卡片视图'">
                  <RecordCollection
                    @select="select"
                    :isCheckbox="slotProps.expand"
                    @successed="successed"
                    :outSource="dataSource"
                  ></RecordCollection>
                </div>
              </div>
            </div>
          </el-main>
          <el-footer height="70px">
            <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                :current-page.sync="pageIndex"
                :page-size="pageSize"
                v-show="paginationVisible"
                :page-sizes="[10, 30, 50, 100]"
                layout="total, sizes,prev, pager, next, jumper"
                :total="totalCount"
              ></el-pagination>
              <div v-if="searchCondition.length > 0">
                <task-tag :tagList="searchCondition"></task-tag>
              </div>
            </div>
          </el-footer>
        </el-container>
      </template>
    </ayb-container>
  </div>
</template>

<script>
import {
  GetAllRecordByParam,
  GetRecordListByIds,
  GetRecordLuneceQuery,
} from "@/api/modules/basicData/task";
import taskTag from "@/views/task/common/tag.vue";
import chip from "@/components/common/chip.vue";
// import RecordCollection from "./RecordCollection.vue";
import TaskRecordGrid from "./TaskRecordGrid.vue";
import RecordSelect from "./RecordSelect.vue";
import TaskRecordSearch from "./TaskRecordSearch.vue";
import SideTagsRecordDialog from "../components/SideTagsRecordDialog.vue";
import { getToken } from "@/util/auth";
import { mapState } from "vuex";
const cookieUser = getToken();
export default {
  components: {
    RecordCollection: () => import("./RecordCollection.vue"),
    contextmenuRecord: () =>
      import("@/views/task/common/contextmenuRecord.vue"),
    TaskRecordSearch,
    taskTag,
    SideTagsRecordDialog,
    // SideTagsRecordDialog: () =>
    //   import("../components/SideTagsRecordDialog.vue"),
    RecordSelect,
    TaskRecordGrid,
    chip,
  },
  props: {
    isSelectStyle: {
      //是否是工作记录选择界面
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contextmenuRow: {},
      columns: [
        {
          text: "标题",
          value: "NAME",
        },
      ],
      searchCondition: [],
      tabHeight: ($(window).height() - 150).toString(),
      tabHeight1: ($(window).height() - 150).toString(),
      searchStyle: 0, //0为搜索模板 1为结果集 //2是精确搜素
      filedID: "ID",
      templateData: null,
      templateTitle: "工作记录面板管理",
      bigTemplateTitle: "工作记录",
      pageIndex: 1,
      pageSize: 10,
      paginationVisible: true,
      totalCount: 0,
      para: {},
      selectItem: {
        label: "所有记录",
        value: "-1",
      },
      isLuceneSearch: false,
      stateName: "卡片视图",
      searchTxt: "", //全文检索
      dataSource: [],
      loading: false,
      options: [
        {
          label: "所有记录",
          value: "-1",
        },
        {
          label: "我创建的",
          value: "0",
        },
        {
          label: "我关注的",
          value: "2",
        },
        {
          label: "他人创建的",
          value: "1",
        },
        // {label:"最近一周",value:"0"},
        //   {label:"最近一月",value:"0"},
      ],
    };
  },
  computed: {
    ...mapState({
      resultList: (state) => state.resultBase.resultList,
      isCheckbox: (state) => state.task.isCheckbox,
    }),
  },
  methods: {
    handleRightRow(obj) {
      console.log(obj);
      let event = obj.event;
      event.preventDefault();
      this.contextmenuRow = obj.row;
      const postition = {
        top: event.clientY,
        left: event.clientX,
      };
      this.$refs.contextmenuRecord.Show(postition);
    },
    getSelectedResult(vals) {
      this.$emit("getSelectedResult", vals);
    },
    successed() {
      if (this.searchStyle == 2) this.searchRecord(this.para);
      else this.getRecordByTemplateData(this.templateData);
    },
    createTemplate(content) {
      this.$refs.templateTag.createTemplate(content);
    },
    deleteResult(data) {
      if (data) {
        console.log("deleteResult", data);
        data.forEach((row) => {
          this.getCardChecked(row, false);
          this.$refs.multipleTable.toggleRowSelection(row, false);
        });
      } else {
        this.dataSource.forEach((v) => {
          v.checked = false;
        });
        this.$refs.multipleTable.clearSelection();
      }
    },
    getCardChecked(row, checked) {
      // this.dataSource.forEach(v => {
      //   if (row[this.filedID] === v[this.filedID]) v.checked = checked;
      // });

      this.dataSource.forEach((v, index) => {
        // 首先这里通过遍历数组改变元素的值，不能直接进行赋值更改，否则无法被监听到
        // item = '你好'
        // 需要用$set方法进行赋值
        if (row[this.filedID] === v[this.filedID]) {
          v.checked = checked;
          this.$set(this.dataSource, index, v);
        }
      });
    },
    getLeftAndAll() {
      this.$refs.templateTag.getLeftAndAll();
    },
    select(row, isAddOrDelete) {
      if (isAddOrDelete) {
        this.$refs.templateTag.add(row);
        this.getCardChecked(row, true);
      } else {
        this.$refs.templateTag.delete(row);
        this.getCardChecked(row, false);
      }
    },
    selectAll(selection) {
      if (selection.length > 0) {
        //全选事件
        selection.forEach((c) => {
          this.$refs.templateTag.add(c);
          this.getCardChecked(c, true);
        });
      } else {
        this.dataSource.forEach((c) => {
          this.$refs.templateTag.delete(c);
          this.getCardChecked(c, false);
        });
      }
    },
    addRecord() {
      this.$refs.SideTagsRecordDialog.dialogFormVisible = true;
      this.$refs.SideTagsRecordDialog.type = 0;
      // this.$refs.SideTagsRecordDialog.task = this.task;
    },
    showSearch(data, type) {
      console.log("showSearch", data, type);
      this.$refs.recordSearch.open(data, type);
    },
    searchFullText() {
      console.log("searchTxt", this.searchTxt);
      this.pageIndex = 1;
      if (this.searchTxt) {
        console.log("searchLucene");
        this.isLuceneSearch = true;
        this.searchLuceneApi();
      } else {
        console.log("searchRecord");
        this.isLuceneSearch = false;
        this.getRecordByTemplateData(this.templateData);
      }
    },
    //全文检索
    searchLuceneApi() {
      this.loading = true;
      GetRecordLuneceQuery(this.pageIndex, this.pageSize, this.searchTxt, {
        CurrentUserId: cookieUser.userId,
      }).then((result) => {
        this.loading = false;
        if (result) {
          console.log("searchLuceneApi", result);
          this.totalCount = result.TotalItems;
          result.Items.forEach((v) => {
            v.checked = false;
          });
          this.dataSource = [];
          result.Items.forEach((item) => {
            item.INFO = this.imgPreview(item.INFO);
          });
          this.dataSource = result.Items;
          console.log("searchLuceneApi2", this.dataSource);
        }
      });
    },
    //搜索工作记录
    searchRecord(recordPara) {
      this.searchStyle = 2;

      this.isLuceneSearch = false;
      this.pageIndex = 1;
      this.para = recordPara;
      this.searchRecordApi();
    },
    searchRecordApi() {
      this.loading = true;
      if (this.para.CreateMe) {
        if (this.para.CreateUserIds) {
          this.para.CreateUserIds =
            this.para.CreateUserIds + "," + cookieUser.userId;
        } else {
          this.para.CreateUserIds = cookieUser.userId;
        }
      }
      if (this.para.ExcuteMe) {
        if (this.para.ExcuteUserIds) {
          this.para.ExcuteUserIds =
            this.para.ExcuteUserIds + "," + cookieUser.userId;
        } else {
          this.para.ExcuteUserIds = cookieUser.userId;
        }
      }

      if (this.para.CreateDeptMe) {
        if (this.para.CreateDeptIds) {
          this.para.CreateDeptIds =
            this.para.CreateDeptIds + "," + cookieUser.departmentId;
        } else {
          this.para.CreateDeptIds = cookieUser.departmentId;
        }
      }
      this.para.CurUserId = cookieUser.userId;
      if (this.para.Alone) {
        this.searchCondition = this.para.Alone;
      } else this.searchCondition = [];

      GetAllRecordByParam(this.pageIndex, this.pageSize, this.para).then(
        (result) => {
          this.loading = false;
          if (result) {
            console.log("GetAllRecordByParam", result);
            this.totalCount = result.TotalItems;
            result.Items.forEach((item) => {
              item.INFO = this.imgPreview(item.INFO);
            });
            this.dataSource = result.Items;
          }
        }
      );
    },
    addRecordReport() {
      this.$refs.recordSelectDialog.dialogVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.searchStyle != 1) this.refershSource();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      if (this.searchStyle != 1) this.refershSource();
    },
    refershSource() {
      if (this.isLuceneSearch) {
        this.searchLuceneApi();
      } else {
        this.searchRecordApi();
      }
    },
    GetRecordListByIds(recordIds) {
      // 1:结果集
      this.loading = true;
      GetRecordListByIds(recordIds, cookieUser.userId).then((result) => {
        this.loading = false;
        if (result) {
          result.forEach((item) => {
            item.INFO = this.imgPreview(item.INFO);
          });
          this.dataSource = result;
          console.log("GetRecordListByIds", this.dataSource);
          this.totalCount = this.dataSource.length;
          this.source.forEach((c) => {
            this.$store.commit("addResult", {
              row: c,
              filed: this.filedID,
              key: c[this.filedID],
              bol: false,
            });
          });
        }
      });
    },
    getRecordByTemplateData(data) {
      this.pageIndex = 1;
      console.log("点击执行User-->data:", data);
      if (!data) {
        this.searchFullText();
      }
      this.templateData = data;
      // 点击树结构模板动态查询
      if (data.TEMPTYPE == 0) {
        //0:搜索模板
        let content = JSON.parse(data.CONTENT);
        this.searchStyle = 0;
        this.recordIds = "";
        if (content) {
          this.para = content.Alone;
          this.searchRecordApi();
        }
      } else if (data.TEMPTYPE == 1) {
        this.pageIndex = 1;
        this.para = {
          SelectIndex: -1,
          RecordType: -1,
          CreateMe: false,
          Degree: 0,
          CreateDeptMe: false,
          CreatetimeRange: [], //创建时间
          CreatetimeRadio: "", //创建时间选择
          CreatetimeInput: "", //创建时间填写
          CreateTimeDynamic: 1, //创建时间（小时,天，周，月）
          CurUserId: cookieUser.userId,
        };
        this.searchStyle = 1;
        this.GetRecordListByIds(data.CONTENT);
      }
    },
  },
  watch: {
    searchCondition(val) {
      if (val.length > 0) {
        this.tabHeight = this.tabHeight1 - 30;
      }
    },
    isSelectStyle: {
      handler(val) {
        if (val) {
          this.stateName = "列表视图";
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.recordPanel > .el-divider {
  margin-bottom: 0px !important;
  margin-top: 8px !important;
}
</style
><style scoped>
.recordPanel {
  margin: 2px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}
.pagination {
  background: white;
  position: fixed;
  bottom: 5px;
}
</style>
